export default "__VITE_ASSET__DCD68okN__"